export default __webpack_public_path__ + "static/national-map-c0593dfc346ae0e53989d9af7821e5d2.svg";